import type { RetailOrderLineItem } from '~/api/graphql/generated/types'
import {
  getIsRetailOrderLineItem,
  isGroupedInvoiceItem,
} from '~/components/dashboard/invoices/invoiceUtils'
import type { InvoiceLineItem } from '~/types'

export const findParentByBundleId = (
  item: InvoiceLineItem | RetailOrderLineItem | undefined,
  items: (InvoiceLineItem | RetailOrderLineItem)[],
): InvoiceLineItem | RetailOrderLineItem | undefined => {
  if (
    !item ||
    isGroupedInvoiceItem(item) ||
    getIsRetailOrderLineItem(item) ||
    !item.bundleId
  ) {
    return undefined
  }

  return items.find(
    (potentialParent) =>
      isGroupedInvoiceItem(potentialParent) &&
      !getIsRetailOrderLineItem(potentialParent) &&
      potentialParent.id === item.bundleId,
  )
}

export const findParentByGroupSnapshotId = (
  item: InvoiceLineItem | RetailOrderLineItem | undefined,
  items: (InvoiceLineItem | RetailOrderLineItem)[],
): InvoiceLineItem | RetailOrderLineItem | undefined => {
  if (
    !item ||
    isGroupedInvoiceItem(item) ||
    getIsRetailOrderLineItem(item) ||
    !item.groupSnapshotId
  ) {
    return undefined
  }

  return items.find(
    (potentialParent) =>
      isGroupedInvoiceItem(potentialParent) &&
      !getIsRetailOrderLineItem(potentialParent) &&
      potentialParent.items?.some(
        (childItem) => childItem.groupSnapshotId === item.groupSnapshotId,
      ),
  )
}
